// Standard library imports
import React, { useEffect, useState } from 'react';
// Internal module imports
import TabsComponent from '../../../components/Tabs/Tabs';
import Users from './Users';
import CreateUser from '../AddUser';

const UserIndex = ({ customerId, customersData }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [createEditUser, setCreateEditUser] = useState({ status: false, customerId: null, user: null });

    useEffect(() => {
        if (selectedIndex === 0) setCreateEditUser({ status: false, customerId: null, user: {} });
    }, [selectedIndex]);

    const tabs = [
        {
            name: 'Users',
            component: <Users customerId={customerId} setCreateEditUser={setCreateEditUser} setSelectedIndex={setSelectedIndex} />,
            tabId: 1,
        },
        ...(createEditUser.status
            ? [
                  {
                      name: !createEditUser.user?._id ? 'Create User' : 'Edit User',
                      component: (
                          <>
                              <CreateUser
                                  editUser={createEditUser.user}
                                  autoFillCustomerId={createEditUser.customerId}
                                  customersData={customersData}
                                  setSelectedIndex={setSelectedIndex}
                              />
                          </>
                      ),
                  },
              ]
            : []),
    ];

    return (
        <div>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
            />
        </div>
    );
};

export default UserIndex;
